/**
 * @generated SignedSource<<c54176519f84ce5a4d9b86b8bfb8d144>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_issueViewSentiment_SentimentField$data = {
  readonly fieldId: string;
  readonly sentiment: {
    readonly name: string | null | undefined;
    readonly sentimentId: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewLayoutFieldHeading_IssueViewFieldHeading">;
  readonly " $fragmentType": "ui_issueViewSentiment_SentimentField";
};
export type ui_issueViewSentiment_SentimentField$key = {
  readonly " $data"?: ui_issueViewSentiment_SentimentField$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_issueViewSentiment_SentimentField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_issueViewSentiment_SentimentField",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_issueViewLayoutFieldHeading_IssueViewFieldHeading"
    },
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "concreteType": "JiraServiceManagementSentiment",
      "kind": "LinkedField",
      "name": "sentiment",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "sentimentId"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraServiceManagementSentimentField"
};

(node as any).hash = "1fd592aa87eb76267fd71b7a57a811a6";

export default node;
